module.exports = __webpack_public_path__ + "img/black_share.c22d40be.svg";